import { render, staticRenderFns } from "./InsurerPhoneEmail.vue?vue&type=template&id=07920c45"
import script from "./InsurerPhoneEmail.vue?vue&type=script&lang=js"
export * from "./InsurerPhoneEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07920c45')) {
      api.createRecord('07920c45', component.options)
    } else {
      api.reload('07920c45', component.options)
    }
    module.hot.accept("./InsurerPhoneEmail.vue?vue&type=template&id=07920c45", function () {
      api.rerender('07920c45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurer/InsurerPhoneEmail.vue"
export default component.exports